module.exports = __webpack_public_path__ + "static/media/promotions-disabled.97889bc3.png";